module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Chapter 3")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "flourish",
      "src": "images/flourish.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('span', {
    staticClass: "s3"
  }, [_vm._v("\"H")]), _vm._v("old your horses. I heard you the first time!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The door behind the desk opened and a young man only a few years older than Shanna emerged. He walked to the desk and removed a pair of round glasses from his suit pocket, settling them on his nose. Staring at the two mud-spattered figures before him, he gave a haughty sniff.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"And just what are you doing in here?\" the clerk finally asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Obviously, we would like a room,\" Shanna shot back at him, outrage at his imperious stare clear in the tone of her words. No one had ever dared treat her with such disdain!")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"We don't accept unaccompanied women at this hotel,\" the clerk informed her. \"Perhaps you might try Mrs. Clark's boarding house a couple blocks over.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"In case you haven't noticed,\" Shanna said angrily, \"there's a blizzard starting up outside. I'm not about to drag my brother two more blocks in that wind and snow. I demand you give us a room!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Impossible,\" the man said with a nonchalant shrug. \"Besides, we're full up.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Good Lord. Was every man in this blasted town a dunderheaded dolt who thought a woman should bow to their superior masculine gender!?")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"You're lying,\" Shanna spat. \"There are several keys hanging on that board behind you.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Some of our guests prefer to leave their keys here, rather than carry them around with them. I repeat, we're full up.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Shanna leaned across the desk and glared at him. \"And I repeat, you're a liar. You just don't want to rent me a room because I don't have a man with me!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Perhaps,\" the man admitted, refusing to be daunted by the frosty blue depths of Shanna's eyes. \"But I have strict orders from the owner. Unescorted women only cause trouble in a hotel of our class.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Trouble!\" Shanna said with a gasp. \"What possible trouble could a woman and child cause?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Are you a widow?\" the clerk questioned.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Shanna frowned, taken aback by what she felt was an incongruous query on the clerk's part. \"No, I'm not. And what on earth does that have to do with my getting a room?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"If you were a widow, an exception could be made. But since you're not, the rule stands. Women do not travel alone, especially a woman your age, unless they... ah....\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Suddenly it dawned on Shanna what the clerk was hinting at. Her voice rose in astonishment and indignation.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Are you insinuating that I'm a loose woman?\" she demanded, completely forgetting about Toby's young ears taking in her every word. \"A... a....\" Shanna searched her mind for the words her mother would never explain to her. \"A barfly... a tart!?\" She spat the last word at him, a look of fury on her face.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Either remove yourself from these premises, or I'll fetch the sheriff!\" the clerk shouted back across the desk. \"We do not tolerate your ilk here!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"The sheriff's out with the posse! Give me a key, or I'll come around there and show you my ilk!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Dear me, Perkins. What in the world's going on here? I started downstairs to see if we'd had word from my nephew, and here I find you and this lovely young lady caterwauling at each other loud enough to disturb every guest in the hotel.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Shanna glanced toward the new voice to see an elderly lady leaning over the banister of the first landing, an amazed look on her face. Blushing furiously as she realized she didn't know how long the woman had been standing there—or what she might have heard—Shanna dropped her eyes to the floor as the woman moved down the stairwell.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("An uncomfortable silence filled the room, broken only by the older woman's footsteps and the clerk's shuffling feet as he tried to decide whether to stand his ground or escape through the door behind the desk again. The clerk started to turn toward the door, but one glance at the face of the elderly woman now approaching the desk put an end to any thought of flight.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I asked you a question, Perkins,\" the woman said as she stopped beside Shanna. \"Melinda's taking a nap up in our room and I won't have her sleep disturbed. What is this shouting match all about?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Shanna glanced over at the woman in time to meet a pair of bright brown eyes. Snow white, carefully curled hair topped the worn and wrinkled face, which held an expression of assurance that her request for an explanation would be forthcoming immediately. Still embarrassed, Shanna dropped her eyes to the bodice of the neatly pressed black gown the elderly woman wore. Shanna's experienced gaze found several faded and patched places on the gown, but she could tell it had once been a quality garment.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I apologize, ma'am,\" Shanna said quietly, forcing herself to overcome her discomfit and look back at the woman's face. \"My brother and I need a room and this man insists we aren't good enough quality to stay at his hotel.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The elderly woman's brown eyes narrowed dangerously as she turned to the clerk. \"Is that true, Perkins?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Mrs. Garret, just look at them,\" the clerk babbled. \"Why, they're covered in filth and the woman's traveling alone. You know what that means.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"No, Perkins, I have no idea,\" the woman he called Mrs. Garret said in a steely voice. \"You tell me. Could it be she's lost her family in the war? We've got a lot of women even around here like that these days.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"But... but look how dirty....\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"We're dirty because we found ourselves in the middle of a bank robbery the minute we stepped off the stage,\" Shanna fired at the clerk, her indignation renewed with the obvious sympathy she sensed in Mrs. Garret. \"We were luckier than the man who was killed. All we got was a little mud on us.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Bank robbery?\" Mrs. Garret's voice rose in shock and she reached out to grab Shanna's arm. \"My God! When?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"A few minutes ago. I'm surprised you didn't hear all the shooting. The hotel's right next door.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Some... sometimes my hearing isn't what it should be,\" Mrs. Garret admitted. \"And I was napping with Melinda until just now. Please. Tell me what happened.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Before Shanna could answer, Toby stepped from behind her cloak. \"It was terrible,\" he said. \"There was a whole bunch of men and one of them pointed his gun at us. But he killed the man who came up the street instead. It wasn't nothing like they try to tell you it is in books.\" Toby hunched his small shoulders and shivered slightly as he concentrated on his words. \"Real life's different than books, ain't it, Shanna?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Isn't,\" Shanna corrected. She looked at Mrs. Garret to see the woman's hand at her breast and a white pallor on her face. When Mrs. Garret swayed, Shanna grabbed her waist and assisted her to one of the chairs at the side of the lobby.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Please rest, ma'am,\" Shanna said in concern. \"Do you want me to have the clerk send for the doctor?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"No,\" Mrs. Garret gasped. \"The man... the man who was killed? Who was it?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I don't know....\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The clerk scurried over as Shanna spoke. \"It was one of the divinity students from the school, Mrs. Garret. George Wymore. They brought him to the morgue out back of the hotel. I let them in and that's where I was when this woman came in for a room.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Not Cody, then,\" Mrs. Garret said, a look of relief coming into her face with the returning color. \"Of course, I'm dreadfully sorry about the young student,\" she added quickly. \"But... I thought for a moment... Cody was due here about now.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"He went with the posse, ma'am.\" Toby carefully took her gnarled hand in his small one and patted it. \"Don't worry. He saved mine and Shanna's life, and then the sheriff asked him to go with him.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"How do you know that, Toby?\" Shanna asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"That was his name, don't you remember, Shanna? He was the man who got us into the building when that robber was going to shoot us. I heard the sheriff call him Cody.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I guess I was too frightened to recall his name. Is Cody rather tall and broad-shouldered, with chestnut hair and brown eyes?\" Shanna questioned. \"He was wearing a sheepskin-lined coat and denim trousers.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"That sounds like my Cody,\" Mrs. Garret replied. \"He's a very nice looking young man.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I... I d... didn't notice that,\" Shanna stuttered.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"But you seemed to describe him so well,\" Mrs. Garret said with a smile. \"You must have gotten a pretty close look at him.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Heck,\" Toby said. \"We should have. He was lyin' under us and on top of us for long enough. That's part of the reason we're so dirty. He had a bunch of mud on him.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Toby!\" Shanna cried. Another blush stole over her cheeks and her knees threatened to give way at the remembered feel of those hard thighs wrapped around her own. \"He was only protecting us from the glass from the windows those robbers shot out. And I'll thank you not to use words so close to profanity! Heck is not a nice word!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Sorry, Shanna. I didn't know what that word meant. Eddie pointed it out in one of his books.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Shanna glanced at Mrs. Garret to see her stifling laughter, her brown eyes twinkling merrily.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I understand what you're going through, my dear,\" Mrs. Garret said. \"Why, Cody's Melinda is about a year younger than this young man and sometimes I have a time with her. Her mother's dead,\" she continued in a softer voice as she studied the blond-haired woman in front of her. \"And Melinda's quite a handful for someone my age.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I'm sure she must be,\" Shanna agreed. \"I wish you would thank Cody again for me when you see him. I didn't really do that properly.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I will, my dear. I guess Melinda and I'll just have to wait here until Cody returns before we can head home.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"That might be a while, Mrs. Garret,\" the clerk informed her. \"There's quite a blizzard blowing up outside.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Then we'll wait it out snug in the rooms upstairs, won't we, Perkins?\" Mrs. Garret said with a stern look at the clerk. \"That is, as soon as you give this young woman a key. And while you're at it, I'll take a key for Cody when he returns. We may be another day or so before going back to the plantation.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Of... of course, Mrs. Garret,\" the clerk said. \"Right away, ma'am.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Mrs. Garret watched the clerk hurry over to the desk, then shook her head as she turned back to Shanna. \"That man needs to be taken down a peg or two. Now, you know my name. I'm Bessie Garret and Cody's my nephew. Most folks just call me Aunt Bessie, though.\" She shot a glance at the clerk. \"Except for those I insist do otherwise. And you two are...?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Shanna V... Allen,\" Shanna stuttered, strangely loath to lie to this woman. But it was necessary, she reminded herself as she introduced Toby. \"And this is my little brother, Toby.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Pleased to meet you, Toby.\" Bessie nodded and received Toby's polite greeting in return. \"You've just arrived in Liberty, I presume?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yes, ma'am,\" Shanna confirmed.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Silence lingered for a moment while Bessie waited for Shanna to continue. As soon as she realized the young woman would volunteer no more information, Bessie led the way back to the desk. After waiting until Shanna signed the register and paid the clerk from the reticule hanging on her arm, Bessie turned to the stairwell.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I'll show you where your room is,\" Bessie said. \"It's just across the hall from mine. And I'm sure Perkins will have some food and hot bath water sent up as soon as he can arrange it, won't you, Perkins?\" she said over her shoulder. \"And the little boy seems to have injured his hand. Don't forget to bring your medicine kit, so his sister can rebandage the wound.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yes, Mrs. Garret,\" the clerk replied.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"What's a barfly, Shanna?\" Toby questioned as he followed Shanna toward the stairwell.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Shush, Toby,\" was Shanna's only reply.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I suppose that's something else we'll talk about later,\" Toby muttered not quite loud enough to reach Shanna's ears and draw a censuring look from her.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("* * *")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("An hour later, Shanna gazed down at Toby's small form, huddled under the blanket on the double bed. One hand lay on top of the blanket, a clean bandage replacing the handkerchief Shanna had rinsed out in the bath water and spread to dry on the back of the rocking chair beside the fireplace. Further examination had proven the cut was indeed minor, despite the amount of blood that had flowed from it. Toby would probably sleep for an hour or two now, his stomach full and his little body scrubbed clean, though not without another somewhat grouchy protest about a bath on any other day than Saturday.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Shanna gazed longingly at the other pillow for a second, but a nap right now would leave her sleepless tonight. And she'd had enough tossing and turning nights the last few weeks to last a lifetime—nights filled with unanswered questions and visions of a cold, empty future facing her if her one and only plan disintegrated into the dust of failed ventures.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Instead, she reached to loosen the belt on her dressing gown, which she had allowed herself the luxury of wearing until after they ate, and decided to investigate her carpetbag for the cleanest gown with the fewest wrinkles.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Loud, clumping footsteps sounded in the hallway, halting just outside Shanna's door. Shanna hesitated, waiting for a knock to sound, then decided whoever it was must be going to the room across the hallway. Mrs. Garret's nephew was probably back. Cody. Cody Garret, she guessed his name might be. Shanna unthinkingly hurried to the door, her curiosity as to whether the robbers had been caught making her forget her improper appearance.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Toby, too, would want to know, she thought as she pulled the door open. And maybe if she at least properly thanked the man, she could get him out of her mind once and for all. She would ignore their confrontation over Toby and....")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The chiseled face that turned toward her when the door squeaked made Shanna gulp and realize she should have waited to ask Bessie Garret the outcome of the manhunt. It contained eyes darkened to mahogany in fatigue and lips that lost their fullness when he tightened his mouth grimly and swept his gaze over her.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I... I just wanted to know if you'd caught the robbers,\" Shanna said quickly.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"What do you care?\" Cody asked in a tired voice. \"You didn't have any money in the bank.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Toby,\" she hastened to explain. \"He'll want to know.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Tell him they got plumb away. They split up and went ten different directions and we never even got close enough to follow a trail before the snow covered it.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I'm sorry. Really. I know I didn't lose anything, but that doesn't mean I don't care about the people who did. Will it mean an awful hardship for them?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cody removed his hat and swiped his fingers through the flattened, chestnut locks of hair, tousling them into new life. He rested his palm on the back of his head, the heavy coat gaping and the tan shirt beneath it taut with strain across his chest. Deep lines of concern etched his face, both from weariness and worry, making Shanna wish for an instant that she could say something to ease them—or brush them away with her fingertips.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Shanna thrust her arms behind her, clenched into fists to still her wavering fingers.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Hardship?\" Cody said with a shake of his head as he stared at the floor. \"Disaster might be more like it. Hell, we've just got started rebuilding around here and now most of us won't have any money for seed to plant this spring. And what's more, the bank won't be able to help us out. Taxes are coming due and....\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Shanna unconsciously took a step forward, the gravelly words stirring her and her heart swelling with compassion at the agony she sensed underlying his voice.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I'm sorry. What will you do?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Do?\" Cody said with a shrug, his eyes drawn to the tiny slippered foot peeping out from under the dressing gown, then travelling up the skirt to where the belt hung loosely around a waist he could easily span with his fingers and thumbs.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Well,\" he said with a wry twist to his mouth, \"we sure won't sit around pitying ourselves.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"No, I don't imagine you will. The people here seem like they're extremely capable of banding together and taking care of their problems. It didn't take the sheriff long to get a posse together. If it hadn't been for the snowstorm, I'm sure they would have caught those bandits and gotten their money back.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cody kept silent and flickered his gaze on upward. The orchid dressing gown gaped where her breasts swelled, allowing a glimpse of white lace. The promise of fullness he had felt when he covered her with his body in the land office was fulfilled now that the woolen cloak didn't impede his discovery.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I....\" Shanna licked full, pink lips gone dry, with a tongue just as powdery. \"I also wanted to tell you something else.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Ummmm?\" The slender neck was graceful beneath the stubborn little chin that had lifted in defiance when she tried to interfere in his talk with her little brother. Well, hell, he had been too abrupt with Toby—his patience at an end after dodging flying lead and failing to keep his bank account safe. He ought to apologize....")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("That golden hair, tied back with a matching orchid ribbon, cascaded down past that enticingly minute waist....")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I wanted to thank you properly for what you did for Toby and me,\" Shanna said, interrupting his pleasant thoughts. \"Not... not interfering with Toby,\" she qualified. \"But he seems to have accepted that. However, I realize now just how much danger you put yourself in to get us out of harm's way. The clerk....\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Shanna cleared her throat, confused at how hoarse her voice was getting as Cody silently studied her and waited for her to continue.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"The clerk confirmed that the man out in the street was killed. It could very easily have been me or—thank the Lord it wasn't Toby. And thank you. I wish I could think of something stronger to say to let you know how much I appreciate what you did, but thank you is all I can think....\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Shanna clamped her mouth shut when she realized she was babbling. What in the world was it about this man that muddled her senses so? Her teeth tugged at her bottom lip as she ordered her legs to take her back into her room and her arms to close the door. She'd told him what she had to say, quite adequately thanked him this time.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She stood rooted in place, though, when he took a step forward.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Sometimes words fall short,\" Cody agreed in a musing voice. \"I don't guess I'd be adverse to you "), _c('i', [_vm._v("showing")]), _vm._v(" me your appreciation.\" He raised one hand to caress her cheek with the back of his index finger, while his other hand, out of Shanna's line of vision, flipped the sagging belt of the dressing gown free.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Shanna's lips parted slightly and her eyes widened into pools of cobalt. Her indrawn breath caught in her chest, swelling her breasts and crinkling her nipples when they rubbed against the stiff lace of her undergown. His arm snaked around her waist and his fingers played against the full swell of her hip, kneading it as he lowered his head. A spreading warmth flowed down her legs from her feminine center.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cody's lips nibbled gently at first and Shanna fought the lassitude spreading through her, her eyelids slowly descending. The instant the long, feathery lashes met the curve of her cheek, Cody took her mouth fully and pulled her close against the length of his body.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She had been right, Shanna thought as her arms fell into place around his corded neck. There was a haven in his strong arms—a place she could steal away from the maelstrom in her life.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cody's lips released hers and traced a path down the delectable neck, tasting it and then flickering his tongue up toward the full earlobe.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Why don't I go get a room key so we can continue this in privacy?\" he whispered.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Shanna gasped in horror and wrenched free, her thigh brushing against a strange protuberance below Cody's waist with her movements. The dressing gown slithered off her shoulders and she grabbed it, pulling it back up, her fingers searching wildly for her belt.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"You... you... you... bastard!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cody smiled smugly, then bent down to retrieve her belt and his hat from where he had dropped them on the floor. He plopped the hat on his head and pushed it back, dangling the belt from one long finger.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"My, my, Shanna,\" he growled low in his throat. \"You certainly do have a problem finding words. If you'll remember, you've already called me that once. No wonder you had to show me your appreciation, rather than voicing it.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Shanna swiped the belt from his hand, her blue eyes changing to aquamarine and spitting those familiar daggers at him. He chuckled wryly while she wrapped the belt around her waist and glared at him.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"You are an insufferable, conceited ass,\" she snarled. \"I had thought there might be a measure of decency about you, since you have such a marvelous aunt. However, my heart goes out to Bessie. She definitely has a cross to bear with such an unfeeling clod for a nephew!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Now just a damn minute...!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("But Cody found himself talking to the unyielding door, the resounding slam echoing in his ears and drowning out his words.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cody's anger died a hasty death and a snicker of mirth escaped his lips. She'd definitely found some different words to use. And he was right. Fire and ice. Ice and fire. Banked fires, but nevertheless still there.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Rather than the observation placing an effective wet blanket on his ardor, though, Cody found himself more than a little intrigued again.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Ardor, hell! Intrigue! Here he was thinking in the high-faluting, overblown language he had taunted that delightful little package of contradictions into using.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("What was it about her that goaded him into implausible actions, he wondered as he stared at the closed door. Granted, there was an air of vulnerability about her that tugged at him—made him want to wrap her in his arms and kiss away any pain she had suffered, cocoon her from any danger waiting in the wings of her future. And that body fit just exactly so against his, sexy curves snuggling into those sensitive spots he had almost forgotten during these last few years of war, grief and rebuilding the plantation.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("That had to be it. He'd been too long without a woman and the stiffness bulging against his denims was pure, down-to-earth sex—lust. He was going to have to stand here a few minutes until it subsided or risk Bessie's knowing gaze when he removed his coat. His aunt didn't miss much. Besides, he didn't think he could walk just yet.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Bessie silently closed the door she had opened at the sound of the ringing slam across the hallway, leaving her nephew alone, chuckling to himself and fixated on the door across the hallway. She'd give her eyeteeth to have been privy to the few minutes preceding that slamming door!")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Oh, well, she wasn't about to let the friction evidently boiling between Cody and that sweet little Yankee spoil the plans she had spent the last hour or so finalizing in her mind.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23d5a9e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section7.vue
// module id = 78
// module chunks = 0